export const emptyResponse = { data: [], meta: { total: 0 } };
